import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  resetChangePasswordForm,
  changePassword
} from 'actions/authActions';
import ChangeTempPasswordForm from './changeTempPasswordForm';
import ChangeTempPasswordSuccess from './changeTempPasswordSuccess';

@connect(
  state => ({
    auth: state.auth
  }),
  {
    resetChangePasswordForm,
    changePassword
  }
)
export default class ChangeTempPassword extends Component {

  static propTypes = {
    auth: PropTypes.object,
    resetChangePasswordForm: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);
    this.state = {
      accepted: false
    };
  }

  componentWillMount () {
    const {
      auth,
      resetChangePasswordForm: resetForm
    } = this.props;
    if (auth) {
      resetForm(auth.tempPassword);
    }
  }

  componentWillReceiveProps (nextProps) {
    const {
      auth: {
        tempPassword: oldTempPassword
      }
    } = this.props;
    const {
      auth: {
        tempPassword: newTempPassword
      },
      resetChangePasswordForm: resetForm
    } = nextProps;
    if (newTempPassword !== oldTempPassword) {
      resetForm(newTempPassword);
    }
  }

  handleSubmit (data) {
    const {
      auth: {
        authData: {
          password: {
            email
          }
        }
      }
    } = this.props;
    const { oldPassword, newPassword } = data;
    return this.props.changePassword({
      email,
      oldPassword,
      newPassword
    }).then(() => {
      this.setState({
        accepted: true
      });
    });
  }

  render () {
    const { auth: { tempPassword } } = this.props;
    const { accepted } = this.state;

    if (!accepted) {
      return (
        <div>
          <h1>Choose a New Password</h1>

          <p>
            Please create a new password to replace your temporary password.
          </p>

          <ChangeTempPasswordForm
              tempPassword={tempPassword}
              onSubmit={::this.handleSubmit} />
        </div>
      );
    } else {
      return <ChangeTempPasswordSuccess />;
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/changeTempPassword.jsx